export function isValidationError(error) {
    return codeEqualsTo(error, 400);
}

function codeEqualsTo(error, code) {
    return error.code === code;
}

export function isUnauthorizeError(error) {
    return codeEqualsTo(error, 401);
}

export function isForbiddenError(error) {
    return codeEqualsTo(error, 403);
}

export function isInternalServer(error) {
    return codeEqualsTo(error, 500);
}

export function isNotFoundError(error) {
    return codeEqualsTo(error, 404);
}

export function isNotServerError(error) {
    return !error.code;
}

export function isPaymentError(error) {
    return codeEqualsTo(error, 402);
}

export function isPaymentActionRequiredError(error) {
    return codeEqualsTo(error, 402) && error.message === 'payment-action-required';
}

export function isNoSubscriptionError(error) {
    return codeEqualsTo(error, 402) && error.message === 'Subscription required';
}

export function isErxProfilesFilledError(error) {
    return codeEqualsTo(error, 422) && error.message === 'Profile for erx not filled error';
}



// WEBPACK FOOTER //
// ./src/sources/ApiError.js